export default __webpack_public_path__ + "static/media/user-carts-fill-icon.7d4854a8.svg";